import { t } from 'i18next';
import * as yup from 'yup';

import { AttributeType } from 'companySettings/enums';
import { getEmptyErrorMessage } from 'core/yup';

import { MAX_ATTRIBUTE_NAME_LENGTH } from './constants';
import { AttributeValueSource } from './types';

export const upsertPartFinderProductTypeSchema = () =>
  yup.object().shape({
    name: yup
      .string()
      .label(t('labelName'))
      .trim()
      .nullable()
      .max(MAX_ATTRIBUTE_NAME_LENGTH)
      .required(getEmptyErrorMessage(t('labelName'))),
  });

export const upsertProductTypeAttributeSchema = () =>
  yup.object().shape({
    name: yup
      .string()
      .label(t('labelName'))
      .trim()
      .nullable()
      .max(MAX_ATTRIBUTE_NAME_LENGTH)
      .required(getEmptyErrorMessage(t('labelName'))),
    source: yup.mixed<AttributeValueSource>().oneOf(Object.values(AttributeValueSource)).required(),
    type: yup
      .mixed<AttributeType>()
      .label(t('labelType'))
      .oneOf(Object.values(AttributeType))
      .required(getEmptyErrorMessage(t('labelType'))),
  });
